import { styled } from "@mui/material";

import useRefetchWidget from "@/features/shared/widgets/hooks/useRefetchWidget";
import { replaceParametersInUrl } from "@/features/shared/widgets";

const StyledIFrame = styled("iframe")({
  width: "100%",
  height: "100%",
  border: "none",
});

const IFrame = ({ id, data }: { id: string; data: { url: string } }) => {
  useRefetchWidget(id);

  const url = data?.url;

  if (!url) return null;

  return (
    <StyledIFrame title="iframe" src={replaceParametersInUrl(String(url))}></StyledIFrame>
  );
};

export default IFrame;
